import { render } from "./index.vue?vue&type=template&id=116766eb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=116766eb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/components/footer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "116766eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('116766eb', __exports__)) {
    api.reload('116766eb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=116766eb", () => {
    api.rerender('116766eb', render)
  })

}


export default __exports__